import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import { StyleSheet, View } from 'react-native';
import merge from 'lodash/merge';
import isEmpty from 'lodash/fp/isEmpty';

import Text, { Small } from '@dbk/ui-text';
import styles from './key-value-list-view.styles';
import { NO_DATA } from '../../../../../../src/constants';

import TableRow from '../../../../../../src/components/common/table-row';
import {
  Percent,
  Currency,
  SimpleNumber,
} from '../../../../../../src/components/common/number';
import SimpleDate from '../../../../../../src/components/common/date';
import formatPriceForAsset from '../../../../../../src/utils/asset-currency-roundoff';

function KeyValueListRow({ label, value, unit, posCurr, type, minimumFractionDigits, maximumFractionDigits, messages}) {
  
  function renderDetailsValue() {
    const sharedProps = {
      testID: 'value',
      style: StyleSheet.flatten(styles.currencyLabel),
    };

    let fractions = merge({},
      minimumFractionDigits != undefined
        && { minimumFractionDigits: minimumFractionDigits },
      maximumFractionDigits != undefined
        && { maximumFractionDigits: maximumFractionDigits }
    );
    if (isEmpty(fractions)) fractions = getDefaultFractions(type);

   
    if (value == null) {
      return (
        <div aria-label={messages['app.common.nullValue']}>
          <Text>{NO_DATA}</Text>
        </div>
      )
    }

    if (type === 'date') {
      return (<SimpleDate
        value={value}
        renderProps={{size:"normal", type:"primary"}}
      />);
    }

    if (type === 'currency') {
      return (
        <Currency
          value={value}
          currency={unit || posCurr}
          renderProps={{
            testID: 'value',
            style: (styles.currencyLabel),
            size: 'small',
          }}
          {...fractions}
        />
      );
    }
    if (type === 'customRoundOffcurrency') {
      const roundOffValue = formatPriceForAsset(value);
      fractions = {
        minimumFractionDigits: roundOffValue.fractionalCount,
        maximumFractionDigits: roundOffValue.fractionalCount,
      };
      return (
        <Currency
          value={+roundOffValue.displayedPrice}
          currency={unit || posCurr}
          renderProps={{testID: 'value',
            style: (styles.currencyLabel),
            size: 'small',}}
          {...fractions}
        />
      );
    }

    if (type === 'number') {
      return (
        <SimpleNumber
          value={value}
          renderProps={sharedProps}
          {...fractions}
        />
      );
    }

    if (type === 'percent') {
      return (
        <Percent
          value={value}
          onlyNegativeStyling
          renderProps={sharedProps}
        />
      );
    }

    return <Text {...sharedProps}>{ value }</Text>;
  }

  function getDefaultFractions(type) {
    let defaultFractions = {};
    if (type === 'number') {
      defaultFractions = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      };
    }
    return defaultFractions;
  }

  if (!label) {
    return (
      <View style={StyleSheet.flatten(styles.root)}>
        <View>
          <Text tabIndex={0} testID="label">{value}</Text>
        </View>
      </View>
    );
  }

  return (
      <View style={StyleSheet.flatten(styles.root)} testID="isin-or-purchase-top" accessible={true}>
        <View style={StyleSheet.flatten(styles.itemLeft)} testID="isin-or-purchase" accessibilityLabel={label === messages['app.ch.portfolio.accBalCcy'] ? messages['app.assets.accBalanceInAccCurrency'] : (label === messages['app.ch.portfolio.unrealisedGL'] ? messages['app.assets.unrealizedGainOrLossInPosCurrency'] : label)}>
          <Text secondary testID="label">{label}</Text>
        </View>
        <View style={StyleSheet.flatten(styles.itemRight)} secondary testID="isin-or-purchase">
          {renderDetailsValue()}
        </View>
      </View>
  );
}

KeyValueListRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  unit: PropTypes.string,
  type: PropTypes.string,
  minimumFractionDigits: PropTypes.number,
  maximumFractionDigits: PropTypes.number,
};

export default pure(KeyValueListRow);

